// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3iXN0","content":"styles_content__32j8T","checkbox":"styles_checkbox__bIy2B","checkboxLabel":"styles_checkboxLabel__4fTtk"};